module.exports = __webpack_public_path__ + "img/logoSienf.072838b5.png";